import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateSystemUserRequest,
  InitiatePasswordResetRequest,
  ResetPasswordRequest,
  UpdateSystemUserRequest,
  ViewSystemUserRequest
} from './system-user.types';

import {
  requestCreateSystemUser,
  requestDeleteAccount,
  requestInitiatePasswordReset,
  requestResetPassword,
  requestUpdateSystemUser,
  requestViewSystemUser
} from './system-user.actions';

export const useSystemUserApi = () => {
  const dispatch = useDispatch();

  const createSystemUser = useCallback(
    (requestData: CreateSystemUserRequest, onSuccess?: (programmeName: string) => void) => {
      dispatch(requestCreateSystemUser({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewSystemUser = useCallback(
    (requestData: ViewSystemUserRequest, onSuccess?: () => void) => {
      dispatch(requestViewSystemUser({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updateSystemUser = useCallback(
    (requestData: UpdateSystemUserRequest, onSuccess?: () => void) => {
      dispatch(requestUpdateSystemUser({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const initiatePasswordReset = useCallback(
    (requestData: InitiatePasswordResetRequest, onSuccess?: () => void) => {
      dispatch(requestInitiatePasswordReset({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const resetPassword = useCallback(
    (requestData: ResetPasswordRequest, onSuccess?: () => void) => {
      dispatch(requestResetPassword({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteAccount = useCallback(
    (onSuccess?: () => void) => {
      dispatch(requestDeleteAccount({ onSuccess }));
    },
    [dispatch]
  );

  return { createSystemUser, viewSystemUser, updateSystemUser, initiatePasswordReset, resetPassword, deleteAccount };
};
